// ABOUTME: Service for fetching visitor aggregation stats from the aggregations named source
// ABOUTME: Supports dynamic column selection for gender, age, and visitor profile metrics

import { environment } from '../../../../environments/environment'
import { type CartoClient } from './carto.helper'

export interface AggregationRow {
  min: number
  max: number
  count: number
  avg: number
  sum: number
}

export interface AggregationsFilters {
  delivery_id: number
  delivery_start_date: string
  filter_combined: string
  columns: string[]
}

export async function fetchAggregations(
  cartoClient: CartoClient,
  filters: AggregationsFilters,
  signal?: AbortSignal,
) {
  const { delivery_id, delivery_start_date, filter_combined, columns } = filters

  // CARTO rejects empty array params; ['nvisitors'] is the sentinel the
  // named source recognizes as "no category filter, use the total column".
  const columnsForApi = columns.length === 0 ? ['nvisitors'] : columns

  const response = await cartoClient.query<AggregationRow>({
    source: {
      source: `${environment.CARTO_SOURCE_PREFIX}_aggregations`,
      queryParameters: {
        delivery_id,
        delivery_start_date,
        filter_combined,
        columns: columnsForApi,
      },
    },
    params: {
      column: ['min', 'max', 'count', 'avg', 'sum'],
    },
    signal,
  })

  return response?.rows?.[0] ?? null
}
